import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RewardsWalletService } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-lotto-wallet-details-page',
  templateUrl: './lotto-wallet-details-page.component.html',
  styleUrls: ['./lotto-wallet-details-page.component.scss'],
})
export class LottoWalletDetailsPageComponent implements OnInit {
  id: number;
  screenSize = ScreenType;

  constructor(
    private route: ActivatedRoute,
    private rewardsWalletService: RewardsWalletService
  ) {}

  ngOnInit() {
    this.id = +(this.route.snapshot.paramMap.get('id') || 0);
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
  }
}
